import Image from 'next/image';
import React from 'react';

import AdvertisementCloseButton from './AdvertisementCloseButton';

type AdvertisementCreativeProps = {
    src: string;
    /** Smaller-screen variant of the creative; renders a `<picture>` when set. */
    mobileSrc?: string;
    alt: string;
    width: number;
    height: number;
    imageClassName?: string;
    /** The "Advertisement" label printed in the bottom-right corner. */
    label?: string;
    closeClassName: string;
    onClose?: () => void;
    /** The host's link around the creative; defaults to no link. */
    wrapLink?: (children: React.ReactNode) => React.ReactNode;
};

/** A served ad creative with its optional label and close button — the part the shared and the demo layouts have in common. */
const AdvertisementCreative: React.FC<AdvertisementCreativeProps> = ({
    src,
    mobileSrc,
    alt,
    width,
    height,
    imageClassName,
    label,
    closeClassName,
    onClose,
    wrapLink = (children) => children
}) => {
    const image = (
        <Image
            src={src}
            alt={alt}
            width={width}
            height={height}
            className={imageClassName}
        />
    );

    return (
        <>
            {wrapLink(
                <>
                    {mobileSrc ? (
                        <picture>
                            <source
                                srcSet={mobileSrc}
                                media="(max-width: 1024px)"
                            />
                            {image}
                        </picture>
                    ) : (
                        image
                    )}
                    {label && (
                        <span
                            className="absolute right-[3px] bottom-0 text-body-bold-10 leading-[18px]"
                            style={{ mixBlendMode: 'difference' }}>
                            {label}
                        </span>
                    )}
                </>
            )}
            <AdvertisementCloseButton
                className={closeClassName}
                onClose={onClose}
            />
        </>
    );
};

export default AdvertisementCreative;
